import React from 'react';
import UserProfileSettings from '../../components/UserProfile/UserProfileSettings';
import styles from './Settings.module.css';

const Settings: React.FC = () => {
  return (
    <div className={styles.settings}>
      <UserProfileSettings />
    </div>
  );
};

export default Settings; 